import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import * as actions from '../../../../services/actions';

import AccesRestreins from '../../../../hoc/AccesRestreins/AccesRestreins';
import AttenteRequete from '../../../../hoc/AttenteRequete/AttenteRequete';

import { checkMot } from '../../../../ressources/functionJS/checkMot';
import { confirmeOnClick } from '../../../../ressources/functionJS/confirmeOnClick';
import * as privilege from '../../../../ressources/glossaires/glossaire_privileges';
import * as requestType from '../../../../ressources/glossaires/glossaire_requetes';

import { BiEditAlt, RiDeleteBin2Line } from 'react-icons/all';
import style from '../../../Vue/ProfilVue/ProfilVue.module.scss';
import styles from './ProfilGabarit.module.scss';

import { BsFillInfoCircleFill } from 'react-icons/bs';
import FormulaireGabarit from './FormulaireGabarit/FormulaireGabarit';

const ProfilGabarit = (props) => {
  const [afficheFormulaireModifier, setAfficheFormulaireModifier] =
    useState(false);

  useEffect(() => {
    setAfficheFormulaireModifier(false);
  }, [props.infoSelect]);

  return props.infoSelect ? (
    <div className={styles.profil}>
      <span className={style.style}>
        <BsFillInfoCircleFill size={24} />
      </span>
      <span className={style.style}>
        {checkMot('template_id')} : {props.infoSelect.template_id}
      </span>
      <FormulaireGabarit
        preconfigurerGabarit={props.infoSelect}
        affichageProfil={!afficheFormulaireModifier}
      />
      {afficheFormulaireModifier ? (
        <>
          <button
            className={styles.btM}
            onClick={() => setAfficheFormulaireModifier(false)}
          >
            <BiEditAlt size={24} />
            {checkMot('annuler')}
          </button>
        </>
      ) : (
        <>
          <AccesRestreins numPrivilege={privilege.modifier_des_gabarits}>
            <button
              className={styles.btM}
              onClick={() => setAfficheFormulaireModifier(true)}
            >
              <BiEditAlt size={24} />
              {checkMot('modifier_gabarit')}
            </button>
          </AccesRestreins>
          <AccesRestreins numPrivilege={privilege.supprimer_des_gabarits}>
            <AttenteRequete
              request_type={requestType.supprimer_un_gabarit}
              str={checkMot('suppression_en_cour')}
            >                <button
                className={styles.btF}
                onClick={() =>
                  confirmeOnClick(
                    checkMot('voulez_vous_vraiment_supprimer_ce_gabarit'),
                    () =>
                      props.reqSupprimer(parseInt(props.infoSelect.template_id))
                  )
                }
              >
                <RiDeleteBin2Line size={24} />
                {checkMot('supprimer_gabarit')}
              </button>
            </AttenteRequete>
          </AccesRestreins>
        </>
      )}
    </div>
  ) : (
    checkMot('selectionne_un_gabarit')
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    reqSupprimer: (idGabarit) =>
      dispatch(actions.reqSupprimerGabarit(idGabarit)),
  };
};

export default connect(null, mapDispatchToProps)(ProfilGabarit);
